import { Box, CardContent, CardHeader, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import React, { useContext, useState} from 'react';
import { format } from 'react-string-format';
import { constants } from '../../constants';
import useWebContext from '../../hooks/useWebContext';
import { AuthUserContext } from '../../provider/AuthUserContextProvider';
import { MyMButton, MyMCloseButton } from '../../ui-elements/MyMButton';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMBlackLink } from '../../ui-elements/MyMLink';
import { MyMModal } from '../../ui-elements/MyMModal';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { Pager } from '../../ui-parts/Pager';
import { utility } from '../../utility';
import { RequestBoard } from '../MyM704_RequestBoard/RequestBoard';
import { RequestInfo } from '../MyM706_RequestInfo/RequestInfo';
import useMediaQuery from '@mui/material/useMediaQuery';



/** MyMine Version2.1 RequestHistory画面新規追加
* RequestHistorySearchResult Component
*/
export const RequestHistorySearchResult = (props) => {
  const {
    screenId,
    requestList,
    pageNumber,
    setPageNumber,
    searchCondition,
    callbackUpdateRequest,
  } = props;
  const [requestBoardModalInfo, setRequestBoardModalInfo] = useState({ isOpen: false });
  const [requestInfoModalInfo, setRequestInfoModalInfo] = useState({ isOpen: false, requestSequenceNo: null });
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const theme = useTheme();
  const { authUser } = useContext(AuthUserContext);
  const isMobile = useMediaQuery('(max-width:600px)');


  const onClickAddNewRequest = (props) => {
    setRequestBoardModalInfo({ isOpen: true });
  };

  const handleRequestBoardModalClose = () => {
    setRequestBoardModalInfo({ isOpen: false });
  };

  const handleRequestInfoModalClose = () => {
    setRequestInfoModalInfo({ isOpen: false, requestSequenceNo: null });
  };

  const DeadlineNotifyLabel = ({ item }) => {

    // ANSWER_STATUSがImcomplete以外 又は Deadline日付が未指定の場合、ステータス名称を表示
    if (item.AnswerStatus !== constants.RequestStatus.InComplete || !item.DeadlineDate) {
      return <MyMLabel>{searchCondition.RequestAnswerStatusList.find(x => x.Key === item.AnswerStatus).Value}</MyMLabel>
    }

    // DeadlineDateまでの残り日数
    const daysLeftToDeadline = dayjs(item.DeadlineDate).startOf('day').diff(dayjs().startOf('day'), 'day');
    return daysLeftToDeadline !== null &&
      // 残り日数がしきい値以下の場合、赤字表示
      <MyMLabel sx={{ color: daysLeftToDeadline <= screenSettings.RedNotifyDeadlineDaysLeft ? 'red' : 'inherit', }}>
        {daysLeftToDeadline < 0
          // 残り日数が0を下回る場合、Overdue表示
          ? controlSettings.LabelList.lblDeadlineNotifyOverdue
          // 上記以外の場合、残り日数表示
          : format(controlSettings.LabelList.lblDeadlineNotifyDay, daysLeftToDeadline)}
      </MyMLabel>
  };

  return (
    <Box sx={{ width: '100%', padding:'15px 40px' }}>
      <MyMButton className='mb-2' onClick={onClickAddNewRequest}>{controlSettings.LabelList.btnAddNewRequest}</MyMButton>
      <OutlinedCustomCard>
        <CardHeader
          sx={{ display: 'flex', background: theme.palette.background.secondary, height: '10%' }}
          title={<MyMLabel sx={{ color: 'white' }}>{controlSettings.LabelList.lblRequestListLabel}</MyMLabel>}
        />
        <CardContent sx={{ height: '510px', borderColor: '#999', overflowY: "auto", position: 'relative', p: 0, pb: '1px !important' }} >
          {requestList && requestList.ItemList.length > 0 ? (
            <Box sx={{
              '> .MuiGrid-container > .MuiGrid-item': { pt: 1, pb: 0.5, borderBottom: 'none' },
              '> .MuiGrid-container': { borderBottom: '1px solid #999', p: 1 },
            }} >
              {requestList.ItemList.map((item) => (
  <Grid
    container
    sx={{ bgcolor: item.AnswerStatus !== constants.RequestStatus.InComplete ? '#bdbdbd' : 'initial' }}
    key={item.RequestSequenceNo}
  >
    {isMobile ? (
      // ★モバイル時の並び順
      <>
        <Grid item xs={12}>
          <MyMBlackLink sx={{ maxWidth: '95%' }} onClick={() => setRequestInfoModalInfo({ isOpen: true, requestSequenceNo: item.RequestSequenceNo })}>
            <MyMLabel className='fw-bold text-start text-truncate text-nowrap'>{item.RequestTitle}</MyMLabel>
          </MyMBlackLink>
        </Grid>
        <Grid item xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>
            {controlSettings.LabelList.lblRequestCategoryTitle}
            {searchCondition.RequestCategoryList.find(x => x.Key === item.RequestCategoryId)?.Value}
          </MyMLabel>
        </Grid>
        <Grid item xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>
            {controlSettings.LabelList.lblTargetProductCategoryTitle}
            {searchCondition.TargetProductCategoryList.find(x => x.Key === item.TargetProductCategoryId)?.Value}
          </MyMLabel>
        </Grid>
        <Grid item xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>
            {controlSettings.LabelList.lblDetailTitle}
            {item.RequestContent.replace(/\n/g, ' ')}
          </MyMLabel>
        </Grid>
        <Grid item xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>
            {controlSettings.LabelList.lblCompanyTitle}
            {item.CompanyName}
          </MyMLabel>
        </Grid>
        <Grid item xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>
            {controlSettings.LabelList.lblNameTitle}
            {item.Name}
          </MyMLabel>
        </Grid>
        <Grid item xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>
            {controlSettings.LabelList.lblEmailTitle}
            {item.Email}
          </MyMLabel>
        </Grid>
        <Grid item xs={12}>
          <MyMLabel>
            {controlSettings.LabelList.lblPostDateTitle}
            {utility.formatDate(item.RegistrationDate)}
          </MyMLabel>
        </Grid>
        <Grid item xs={12}>
          <MyMLabel>
            {controlSettings.LabelList.lblDeadlineTitle}
            {utility.formatDate(item.DeadlineDate)}
          </MyMLabel>
        </Grid>
        <Grid item xs={12}>
          <DeadlineNotifyLabel item={item} />
        </Grid>
      </>
    ) : (
      // ★PC時の従来の並び順
      <>
        <Grid item lg={7.5} xs={12}>
          <MyMBlackLink sx={{ maxWidth: '95%' }} onClick={() => setRequestInfoModalInfo({ isOpen: true, requestSequenceNo: item.RequestSequenceNo })}>
            <MyMLabel className='fw-bold text-start text-truncate text-nowrap'>{item.RequestTitle}</MyMLabel>
          </MyMBlackLink>
        </Grid>         
        <Grid item lg={3} sm={6} xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>{controlSettings.LabelList.lblCompanyTitle}{item.CompanyName}</MyMLabel>
        </Grid>
        <Grid item lg={1.5} sm={6} xs={12}>
          <MyMLabel>{controlSettings.LabelList.lblPostDateTitle}{utility.formatDate(item.RegistrationDate)}</MyMLabel>
        </Grid>
        <Grid item lg={3.5} sm={6} xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>{controlSettings.LabelList.lblRequestCategoryTitle}{searchCondition.RequestCategoryList.find(x => x.Key === item.RequestCategoryId)?.Value}</MyMLabel>
        </Grid>
        <Grid item lg={4} sm={6} xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>{controlSettings.LabelList.lblTargetProductCategoryTitle}{searchCondition.TargetProductCategoryList.find(x => x.Key === item.TargetProductCategoryId)?.Value}</MyMLabel>
        </Grid>
        <Grid item lg={3} sm={6} xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>{controlSettings.LabelList.lblNameTitle}{item.Name}</MyMLabel>
        </Grid>
        <Grid item lg={1.5} sm={6} xs={12}>
          <MyMLabel>{controlSettings.LabelList.lblDeadlineTitle}{utility.formatDate(item.DeadlineDate)}</MyMLabel>
        </Grid>
        <Grid item lg={7.5} xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>{controlSettings.LabelList.lblDetailTitle}{item.RequestContent.replace(/\n/g, ' ')}</MyMLabel>
        </Grid>
        <Grid item lg={3} sm={4} xs={12}>
          <MyMLabel className='text-truncate text-nowrap' sx={{ maxWidth: '95%' }}>{controlSettings.LabelList.lblEmailTitle}{item.Email}</MyMLabel>
        </Grid>
        <Grid item lg={1.5} xs={12}>
          <DeadlineNotifyLabel item={item} />
        </Grid>
      </>
    )}
  </Grid>
))}

            </Box>
          ) : (
            <MyMLabel sx={{ margin: "1vw" }}>{messageList.MyM_MSG_I_0059}</MyMLabel>
          )}
        </CardContent>
      </OutlinedCustomCard>

      <Pager
        resultListItem={requestList}
        handleChangePage={(pageNum) => setPageNumber(pageNum)}
        labelList={controlSettings.LabelList}
        pageNumber={pageNumber}>
      </Pager>

      <Box align='right' marginRight='1rem'>
        <MyMCloseButton closeText={controlSettings.LabelList.btnClose} />
      </Box>

      <MyMModal open={requestInfoModalInfo.isOpen} onClose={handleRequestInfoModalClose} width='80%' height='95%'>
        <RequestInfo requestSequenceNo={requestInfoModalInfo.requestSequenceNo} handleModalClose={handleRequestInfoModalClose} />
      </MyMModal>

      <MyMModal open={requestBoardModalInfo.isOpen} onClose={handleRequestBoardModalClose} width='80%' height='95%'>
        <RequestBoard authUser={authUser} handleModalClose={handleRequestBoardModalClose} callbackUpdateRequest={callbackUpdateRequest} />
      </MyMModal>
    </Box>
  );
};

export default RequestHistorySearchResult